import { DS_HEIGHT } from '@calm/evexia-design-tokens';
import commonMessages from '@rhg/lang/messages/common';
import { Button, Theme } from '@rhg/libs/material';
import { MouseEvent } from 'react';
import { useIntl } from 'react-intl';
import { ChLink } from '../ch-link';

const styleRoot = {
    zIndex: (theme: Theme) => theme.zIndex.skipToMain,
    position: 'fixed',
    left: -1000,
    borderRadius: 0,
    top: (theme: Theme) =>
        `${DS_HEIGHT.TOOLBAR + theme.semantics.Spacing[4]}px`,
    ['&:focus']: {
        left: 0,
    },
};

export const MAIN_CONTENT_ID = 'main-content';

export default function SkipToMain() {
    const { formatMessage } = useIntl();

    const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        const mainContent = document.getElementById(MAIN_CONTENT_ID);
        if (mainContent) {
            mainContent.focus();
            mainContent.scrollIntoView();
        }
    };

    return (
        <Button
            sx={styleRoot}
            component={ChLink}
            href={`#${MAIN_CONTENT_ID}`}
            onClick={handleClick}
            variant="contained"
            color="secondary"
            trackButton="SkipToMain"
        >
            {formatMessage(commonMessages['common.skip_to_main'])}
        </Button>
    );
}
